import React from "react";
import styled from "styled-components";
import theme from "../../utils/theme";
import { breakpoint } from "../../utils/responsive";

interface TextProps {
  color?: string;
  textAlign?: string;
  header?: string;
  bold?: boolean;
  fontWeight?: number;
  breakSpaces?: string;
  textShadow?: string;
  breakWord?: string;
  condensed?: string;
  mFontSize?: string;
  fontSize?: string;
  whiteSpace?: string;
  style?: React.CSSProperties;
}

const Text = styled.div<TextProps>`
  color: ${(props) => (props?.color ? props.color : theme.primary)};
  text-align: ${(props) => props.textAlign};
  ${(props) => props.header && `margin-bottom: 10px;`}
  ${(props) => props.bold && `font-weight: bold;`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}
  ${(props) => props.breakSpaces && `white-space: break-spaces;`}
  ${(props) => props.textShadow && `text-shadow: ${props.textShadow};`}
  ${(props) => props.breakWord && `word-break: break-word;`}
  white-space: ${(props) =>
    props?.whiteSpace ? props.whiteSpace : "pre-wrap"};

  font-family: Poppins;

  @media ${breakpoint.mobile} {
    font-size: ${(props) =>
      props.mFontSize
        ? props.mFontSize
        : props.fontSize
        ? props.fontSize
        : "16px"};
  }

  @media ${breakpoint.desktop} {
    font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  }
`;

type Props = any;

const Typography = (props: Props) => {
  return <Text {...props} />;
};

export default Typography;
